"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorResult = exports.SuccessResult = void 0;
var features_1 = require("../features");
Object.defineProperty(exports, "SuccessResult", { enumerable: true, get: function () { return features_1.SuccessResult; } });
Object.defineProperty(exports, "ErrorResult", { enumerable: true, get: function () { return features_1.ErrorResult; } });
//# sourceMappingURL=index.js.map